export default __webpack_public_path__ + "static/media/light-ON.5f8f38e8.svg";